import { render } from "./AddAgentModal.vue?vue&type=template&id=5bad611c&scoped=true"
import script from "./AddAgentModal.vue?vue&type=script&lang=js"
export * from "./AddAgentModal.vue?vue&type=script&lang=js"

import "./AddAgentModal.vue?vue&type=style&index=0&id=5bad611c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bad611c"]])

export default __exports__